import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { ISkillLevelResource } from "../../skill-levels";
import { ITopicWork, ITopic, ILearnerLink } from "../../topics";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValueAsIRI } from "../../utils/filters";

export interface IWorkCreateMutationParameters {
    uuid?: string;
    topic: RelationalValue<ITopic>;
    learnerLinks?: ILearnerLink[];
    learnerComment?: string;
    trainerComment?: string;
    validatedSkillLevels?: RelationalValue<ISkillLevelResource>[];
    unvalidatedSkillLevels?: RelationalValue<ISkillLevelResource>[];
    mediaSecured?: string[];
}

export type IWorkCreateMutationResult = ITopicWork;

export const workCreateMutation: IApiMutationFunction<IWorkCreateMutationParameters> = ({
    uuid: providedUuid,
    topic,
    validatedSkillLevels,
    unvalidatedSkillLevels,
    mediaSecured,
    ...data
}) => {
    return {
        method: "POST",
        url: "/works",
        data: {
            ...data,
            uuid: providedUuid ?? uuid(),
            topic: mapRelationalValueAsIRI(EntityTypes.TOPIC, topic),
            validatedSkillLevels: validatedSkillLevels?.map(skillLevel =>
                mapRelationalValueAsIRI(EntityTypes.SKILL_LEVEL, skillLevel),
            ),
            unvalidatedSkillLevels: unvalidatedSkillLevels?.map(skillLevel =>
                mapRelationalValueAsIRI(EntityTypes.SKILL_LEVEL, skillLevel),
            ),
            mediaSecured: mediaSecured?.map(media => mapRelationalValueAsIRI(EntityTypes.MEDIA_SECURED, media)),
        },
    };
};

export const useWorkCreateMutation = createApiMutationHook<IWorkCreateMutationParameters, IWorkCreateMutationResult>(
    workCreateMutation,
);
